import {get} from '../common/remote/base_api'
export const Getpaymentres = (razorpayid,datecreated,customer,refunded) => {
    return get(`admin/get-payment-list/`,{ razorpayid:razorpayid,datecreated:datecreated,customer:customer,refunded:refunded});
  };